fx.ns("shared.components", class CoverThumbFrame extends shared.components.CoverThumb 
{    
    constructor(parameters)
    {
        super(parameters);
    }

    load()
    {
        super.load();

        if (!this.model.creation.isFrame)
            this.ready();
        else
        {
            if (this.model.creation.isFrame) // wood
                this.loadImage(window.location.origin + this.model.creation.borderAsset.content);
            else
                this.ready();
        }
    }

    onImageLoaded()
    {
        this.context.save();
        this.context.drawImage(this.image, 0, 0, this.creationSize.width,  this.creationSize.height);
        this.context.restore();
        this.ready();
    }
});